import { useEffect, useState } from "react";
import Cards from "../../../components/Formularios/Cards/Cards";
import ContainerTitulo from "../../../components/Formularios/Container/ContainerTitulo";
import { Row, Col, Card } from "react-bootstrap";
import {
  mdiCalendarMonthOutline,
  mdiCheckCircle,
  mdiAccountCheck,
  mdiAccountMultipleOutline,
  mdiCheckCircleOutline,
  mdiProgressClock,
  mdiClockAlertOutline,
  mdiDotsVertical,
  mdiRefresh,
  mdiChartLine,
} from "@mdi/js";
import ReactApexChart from "react-apexcharts";
import { endpointPrincipal } from "../../../api/endPoints/endpointPrincipal/endpointPrincipal";
import Icon from "@mdi/react";
import {
  DashboardPrioridadeDto,
  DashboardTotalPorDiaDto,
  DashboardStatusDto,
  DashboardCriadosFechadosDto,
} from "../../../types/dashboard";

const INTERVALO_PAINEL_MS = 30000;
let intervaloPainel: number | null = null;

export function PaineldeControle() {
  const [totalTickets, setTotalTickets] = useState<number>(0);
  const [ticketsFechados, setTicketsFechados] = useState<number>(0);
  const [ticketsEmAtendimento, setTicketsEmAtendimento] = useState<number>(0);
  const [ticketsPendentes, setTicketsPendentes] = useState<number>(0);
  const [ticketsValidacaoCliente, setTicketsValidacaoCliente] = useState<number>(0);
  const [ticketsValidacaoInterna, setTicketsValidacaoInterna] = useState<number>(0);
  const [dadosPrioridade, setDadosPrioridade] = useState<any>({
    series: [
      {
        name: "Tickets",
        data: [],
      },
    ],
    options: {
      chart: {
        type: "bar",
        height: 350,
        toolbar: {
          show: false,
        },
      },
      plotOptions: {
        bar: {
          borderRadius: 4,
          horizontal: false,
        },
      },
      dataLabels: {
        enabled: false,
      },
      xaxis: {
        categories: [],
      },
      colors: ["#4361ee"],
    },
  });

  const [dadosTotalPorDia, setDadosTotalPorDia] = useState<any>({
    series: [
      {
        name: "Total",
        data: [],
      },
    ],
    options: {
      chart: {
        type: "bar",
        height: 350,
        toolbar: {
          show: false,
        },
      },
      plotOptions: {
        bar: {
          borderRadius: 4,
          horizontal: false,
          columnWidth: "60%",
        },
      },
      dataLabels: {
        enabled: false,
      },
      xaxis: {
        categories: [],
        labels: {
          rotate: -45,
          style: {
            fontSize: "12px",
          },
        },
      },
      colors: ["#2ed477"],
    },
  });

  const [dadosStatus, setDadosStatus] = useState<any>({
    series: [],
    options: {
      chart: {
        type: "pie",
        toolbar: {
          show: false,
        },
      },
      labels: [],
      colors: ["#4361ee", "#2ed477", "#f7b731", "#fc5c7d", "#6c757d"],
      responsive: [
        {
          breakpoint: 1200,
          options: {
            chart: {
              width: '100%',
              height: '300px'
            },
            legend: {
              position: 'bottom',
              horizontalAlign: 'center',
              fontSize: '14px',
              itemMargin: {
                horizontal: 8,
                vertical: 5
              }
            }
          }
        },
        {
          breakpoint: 768,
          options: {
            chart: {
              width: '100%',
              height: '280px'
            },
            legend: {
              position: 'bottom',
              fontSize: '12px',
              itemMargin: {
                horizontal: 6,
                vertical: 4
              }
            },
            dataLabels: {
              offset: -10,
              minAngleToShowLabel: 10
            }
          }
        },
        {
          breakpoint: 480,
          options: {
            chart: {
              width: '100%',
              height: '250px'
            },
            legend: {
              position: 'bottom',
              fontSize: '11px',
              itemMargin: {
                horizontal: 4,
                vertical: 3
              }
            },
            dataLabels: {
              offset: -15,
              minAngleToShowLabel: 15
            }
          }
        }
      ],
      dataLabels: {
        enabled: true,
        formatter: function (val: number) {
          return val.toFixed(1) + "%";
        },
        style: {
          fontSize: '12px',
          fontFamily: 'inherit',
          fontWeight: 'normal'
        }
      },
      tooltip: {
        y: {
          formatter: function (val: number) {
            return val + " tickets";
          }
        },
        style: {
          fontSize: '12px'
        }
      },
      legend: {
        position: 'bottom',
        horizontalAlign: 'center',
        fontSize: '14px',
        markers: {
          width: 12,
          height: 12,
          radius: 6
        },
        itemMargin: {
          horizontal: 10,
          vertical: 5
        }
      }
    },
  });

  const [dadosCriadosFechados, setDadosCriadosFechados] = useState<any>({
    series: [
      {
        name: "Criados",
        type: "column",
        data: [],
      },
      {
        name: "Fechados",
        type: "line",
        data: [],
      },
    ],
    options: {
      chart: {
        height: 350,
        type: "line",
        toolbar: {
          show: false,
        },
      },
      stroke: {
        width: [0, 4],
      },
      dataLabels: {
        enabled: false,
      },
      xaxis: {
        categories: [],
        labels: {
          rotate: -45,
          style: {
            fontSize: "12px",
          },
        },
      },
      yaxis: [
        {
          title: {
            text: "Quantidade",
          },
        },
      ],
      colors: ["#4361ee", "#2ed477"],
      tooltip: {
        y: {
          formatter: function (val: number) {
            return val + " tickets";
          },
        },
      },
      legend: {
        position: "top",
        horizontalAlign: "center",
        offsetY: -5,
      },
    },
  });

  useEffect(() => {
    let ativo = true;
    let emAndamento = false;

    const fetchDashboardData = async () => {
      if (emAndamento) return;
      emAndamento = true;
      try {
        const [
          totalResponse,
          fechadosResponse,
          emAtendimentoResponse,
          pendentesResponse,
          validacaoClienteResponse,
          validacaoInternaResponse,
          prioridadesResponse,
          totalPorDiaResponse,
          statusResponse,
          criadosFechadosResponse,
        ] = await Promise.all([
          endpointPrincipal.get("/dashboard/total"),
          endpointPrincipal.get("/dashboard/fechados"),
          endpointPrincipal.get("/dashboard/em-atendimento"),
          endpointPrincipal.get("/dashboard/pendentes"),
          endpointPrincipal.get("/dashboard/validacao-cliente"),
          endpointPrincipal.get("/dashboard/validacao-interna"),
          endpointPrincipal.get("/dashboard/prioridades"),
          endpointPrincipal.get("/dashboard/total-por-dia"),
          endpointPrincipal.get("/dashboard/status"),
          endpointPrincipal.get("/dashboard/criados-fechados"),
        ]);

        if (!ativo) return;

        setTotalTickets(totalResponse.data.total);
        setTicketsFechados(fechadosResponse.data.total);
        setTicketsEmAtendimento(emAtendimentoResponse.data.total);
        setTicketsPendentes(pendentesResponse.data.total);
        setTicketsValidacaoCliente(validacaoClienteResponse.data.total);
        setTicketsValidacaoInterna(validacaoInternaResponse.data.total);

        const prioridadesData: DashboardPrioridadeDto =
          prioridadesResponse.data;
        setDadosPrioridade((atual: any) => ({
          series: [
            {
              name: "Tickets",
              data: prioridadesData.dados,
            },
          ],
          options: {
            ...atual.options,
            xaxis: {
              ...atual.options?.xaxis,
              categories: prioridadesData.categorias,
            },
          },
        }));

        const totalPorDiaData: DashboardTotalPorDiaDto =
          totalPorDiaResponse.data;
        setDadosTotalPorDia((atual: any) => ({
          series: [
            {
              name: "Total",
              data: totalPorDiaData.dados,
            },
          ],
          options: {
            ...atual.options,
            xaxis: {
              ...atual.options?.xaxis,
              categories: totalPorDiaData.categorias,
            },
          },
        }));

        const statusData: DashboardStatusDto = statusResponse.data;
        setDadosStatus((atual: any) => ({
          series: statusData.series,
          options: {
            ...atual.options,
            labels: statusData.labels,
          },
        }));

        const criadosFechadosData: DashboardCriadosFechadosDto =
          criadosFechadosResponse.data;
        setDadosCriadosFechados((atual: any) => ({
          series: [
            {
              name: "Criados",
              type: "column",
              data: criadosFechadosData.criados,
            },
            {
              name: "Fechados",
              type: "line",
              data: criadosFechadosData.fechados,
            },
          ],
          options: {
            ...atual.options,
            xaxis: {
              ...atual.options?.xaxis,
              categories: criadosFechadosData.categorias,
              labels: {
                rotate: -45,
                style: {
                  fontSize: "12px",
                },
              },
            },
          },
        }));
      } catch (error) {
        if (ativo) {
          console.error("Erro ao buscar dados do dashboard:", error);
        }
      } finally {
        emAndamento = false;
      }
    };

    fetchDashboardData();
    if (intervaloPainel !== null) {
      window.clearInterval(intervaloPainel);
    }
    intervaloPainel = window.setInterval(fetchDashboardData, INTERVALO_PAINEL_MS);
    const meuIntervalo = intervaloPainel;
    return () => {
      ativo = false;
      window.clearInterval(meuIntervalo);
      if (intervaloPainel === meuIntervalo) {
        intervaloPainel = null;
      }
    };
  }, []);

  const cardHeaderStyle = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "15px",
  };

  const iconButtonStyle = {
    background: "none",
    border: "none",
    cursor: "pointer",
    padding: "5px",
    marginLeft: "5px",
    color: "#6c757d",
    transition: "color 0.2s",
  };

  return (
    <>
      <div className="container-fluid mt-2">
        <div className="title-container d-flex justify-content-between align-items-center">
          <ContainerTitulo titulo="Painel de Controle" />
        </div>
        <Row className="painel-secao">
          <Col xs={12} sm={6} md={4} lg={2} xl={2}>
            <Cards
              titulosmall="Total"
              dados={totalTickets.toString()}
              icone={mdiAccountMultipleOutline}
              rodape="Total de Tickets"
              cor="#4361ee"
            />
          </Col>
          <Col xs={12} sm={6} md={4} lg={2} xl={2}>
            <Cards
              titulosmall="Fechados"
              dados={ticketsFechados.toString()}
              icone={mdiCheckCircleOutline}
              rodape={"\u00A0"}
              cor="#2ed477"
            />
          </Col>
          <Col xs={12} sm={6} md={4} lg={2} xl={2}>
            <Cards
              titulosmall="Análise"
              dados={ticketsEmAtendimento.toString()}
              icone={mdiProgressClock}
              rodape={"\u00A0"}
              cor="#f7b731"
            />
          </Col>
          <Col xs={12} sm={6} md={4} lg={2} xl={2}>
            <Cards
              titulosmall="Pendentes"
              dados={ticketsPendentes.toString()}
              icone={mdiClockAlertOutline}
              rodape="Ativos"
              cor="#fc5c7d"
            />
          </Col>
          <Col xs={12} sm={6} md={4} lg={2} xl={2}>
            <Cards
              titulosmall="Validação Cliente"
              dados={ticketsValidacaoCliente.toString()}
              icone={mdiAccountCheck}
              rodape={"\u00A0"}
              cor="#4895ef"
            />
          </Col>
          <Col xs={12} sm={6} md={4} lg={2} xl={2}>
            <Cards
              titulosmall="Validação Interna"
              dados={ticketsValidacaoInterna.toString()}
              icone={mdiCheckCircle}
              rodape={"\u00A0"}
              cor="#7209b7"
            />
          </Col>
        </Row>
        <Row className="painel-secao">
          <Col xs={12} sm={6} md={6} lg={6} xl={6}>
            <Card style={{ height: 430, boxShadow: "0 2px 6px rgba(0,0,0,0.1)" }}>
              <Card.Header style={cardHeaderStyle}>
                <Card.Title as="h5" className="mb-0">
                  Tickets por Prioridade
                </Card.Title>
              </Card.Header>
              <Card.Body>
                <ReactApexChart
                  options={dadosPrioridade.options}
                  series={dadosPrioridade.series}
                  type="bar"
                  height={350}
                />
              </Card.Body>
            </Card>
          </Col>
          <Col xs={12} sm={6} md={6} lg={6} xl={6}>
            <Card style={{ height: 430, boxShadow: "0 2px 6px rgba(0,0,0,0.1)" }}>
              <Card.Header style={cardHeaderStyle}>
                <Card.Title as="h5" className="mb-0">
                  Total Tickets Criados por Dia
                </Card.Title>
              </Card.Header>
              <Card.Body>
                <ReactApexChart
                  options={dadosTotalPorDia.options}
                  series={dadosTotalPorDia.series}
                  type="bar"
                  height={350}
                />
              </Card.Body>
            </Card>
          </Col>
          <Col xs={12} sm={6} md={6} lg={6} xl={6}>
            <Card style={{ height: 430, boxShadow: "0 2px 6px rgba(0,0,0,0.1)" }}>
              <Card.Header style={cardHeaderStyle}>
                <Card.Title as="h5" className="mb-0">
                  Percentual de Tickets por Status
                </Card.Title>
              </Card.Header>
              <Card.Body
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexDirection: "column",
                  padding: "10px"
                }}
              >
                <ReactApexChart
                  options={dadosStatus.options}
                  series={dadosStatus.series}
                  type="pie"
                  width="100%"
                  height="100%"
                />
              </Card.Body>
            </Card>
          </Col>
          <Col xs={12} sm={6} md={6} lg={6} xl={6}>
            <Card style={{ height: 430, boxShadow: "0 2px 6px rgba(0,0,0,0.1)" }}>
              <Card.Header style={cardHeaderStyle}>
                <Card.Title as="h5" className="mb-0">
                  Tickets Criados x Fechados por Dia
                </Card.Title>
              </Card.Header>
              <Card.Body>
                <ReactApexChart
                  options={dadosCriadosFechados.options}
                  series={dadosCriadosFechados.series}
                  type="line"
                  height={350}
                />
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>
      <style>
        {`
          .container-fluid {
            max-width: 100%;
            padding: 0;
          }

          .title-container {
            padding: 8px 0px;
            margin-bottom: 8px;
          }

          .mb-4 {
            margin: 0 16px;
          }

          .row {
            margin: 0 0px;
          }

          .row.painel-secao {
            margin-bottom: 24px;
            row-gap: 24px;
          }

          @media screen and (max-width: 412px) {
            .title-container {
              padding: 8px;
            }
            .mb-4, .row {
              margin: 0 8px;
            }
          }
        `}
      </style>
    </>
  );
}
